import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import type { FC } from 'react';

import { StatusBox, warningKind } from '../StatusBox/StatusBox';

type Props = {
  entityName: string;
};

export const ArchivedPlantWarning: FC<Props> = ({ entityName }) => (
  <StatusBox
    title={`This ${entityName} is associated with an archived location`}
    subtitle='Changes will be saved but this location is no longer active.'
    icon={InfoOutlinedIcon}
    kind={warningKind}
  />
);
